import { useState, createContext } from 'react';

export const DrawerContext = createContext<{

    locationDrawer: any, 
    locationViewAdnConversionStatsDrawer: any,
    locationContentStatsDrawer: any,
    locationReviewsStatsDrawer: any,
    reviewsDrawer:any,
    postsDrawer:any,
    scheduledPostsDrawer:any,
    logsDrawer: boolean,
    userDrawer:any,
    configureIADrawer: any, 
    configureIAByLocalDrawer: any, 
    releaseNotesModal: any, 
    setLocationDrawer:React.Dispatch<React.SetStateAction<any>>    
    setLocationReviewsStatsDrawer:React.Dispatch<React.SetStateAction<any>>
    setLocationViewAdnConversionStatsDrawer:React.Dispatch<React.SetStateAction<any>>
    setLocationContentStatsDrawer:React.Dispatch<React.SetStateAction<any>>
    setReviewsDrawer:React.Dispatch<React.SetStateAction<any>>
    setPostsDrawer:React.Dispatch<React.SetStateAction<any>>
    setScheduledPostsDrawer:React.Dispatch<React.SetStateAction<any>>
    setLogsDrawer:React.Dispatch<React.SetStateAction<any>>
    setUserDrawer:React.Dispatch<React.SetStateAction<any>>    
    setConfigureIADrawer:React.Dispatch<React.SetStateAction<any>>    
    setConfigureIAByLocalDrawer:React.Dispatch<React.SetStateAction<any>>    
    setReleaseNotesModal:React.Dispatch<React.SetStateAction<any>>    
}>({
    locationDrawer: null, 
    locationViewAdnConversionStatsDrawer: null,
    locationContentStatsDrawer: null,
    locationReviewsStatsDrawer: null,
    reviewsDrawer: null,
    postsDrawer: null,
    scheduledPostsDrawer: null,
    logsDrawer:false,
    userDrawer:null,
    configureIADrawer: null,
    configureIAByLocalDrawer: null,
    releaseNotesModal: null,
    setLocationDrawer:()=>{},
    setLocationViewAdnConversionStatsDrawer:()=>{},
    setLocationReviewsStatsDrawer:()=>{},
    setLocationContentStatsDrawer:()=>{},
    setReviewsDrawer:()=>{},    
    setPostsDrawer:()=>{},
    setScheduledPostsDrawer:()=>{},
    setLogsDrawer: () => {},
    setUserDrawer:() => {},
    setConfigureIADrawer:() => {},
    setConfigureIAByLocalDrawer:() => {},
    setReleaseNotesModal:() => {}
})
const DrawerProvider: React.FC = ({ children }) => {

    const [locationDrawer, setLocationDrawer] = useState(null);    
    const [locationViewAdnConversionStatsDrawer, setLocationViewAdnConversionStatsDrawer] = useState(null);
    const [locationContentStatsDrawer, setLocationContentStatsDrawer] = useState(null);
    const [locationReviewsStatsDrawer, setLocationReviewsStatsDrawer] = useState(null);
    const [reviewsDrawer, setReviewsDrawer] = useState(null);
    const [postsDrawer, setPostsDrawer] = useState(null);
    const [scheduledPostsDrawer, setScheduledPostsDrawer] = useState(null);
    const [logsDrawer, setLogsDrawer] = useState(false);
    const [userDrawer, setUserDrawer] = useState(null);
    const [configureIADrawer, setConfigureIADrawer] = useState(null);
    const [configureIAByLocalDrawer, setConfigureIAByLocalDrawer] = useState(null);
    const [releaseNotesModal, setReleaseNotesModal] = useState(null);

    return (
        <DrawerContext.Provider value={{                 
                locationViewAdnConversionStatsDrawer, setLocationViewAdnConversionStatsDrawer, 
                locationContentStatsDrawer, setLocationContentStatsDrawer, 
                locationReviewsStatsDrawer, setLocationReviewsStatsDrawer, 
                locationDrawer, setLocationDrawer, 
                reviewsDrawer, setReviewsDrawer, 
                postsDrawer, setPostsDrawer, 
                logsDrawer, setLogsDrawer, 
                userDrawer, setUserDrawer, 
                scheduledPostsDrawer, setScheduledPostsDrawer,
                configureIADrawer, setConfigureIADrawer,
                configureIAByLocalDrawer, setConfigureIAByLocalDrawer,
                releaseNotesModal, setReleaseNotesModal
                }}>
            {children}
        </DrawerContext.Provider>    
    );
};

export default DrawerProvider;